import {React, useEffect, useState} from 'react'
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
import { useStateContext } from '../Views/Context/ContextProvider'
import { NavDropdown } from 'react-bootstrap';
import { 
  FaBell, FaCalendarDay, FaCartPlus, FaHome, FaPowerOff, 
  FaSignOutAlt, FaStore,
  FaBars, FaShoppingBag, FaChartLine, FaUsers,
    
  FaTruck, FaClipboardList, FaStar,
  FaShoppingCart, FaFileInvoice
} from "react-icons/fa";
import Sidebar from '../Views/offCanvas/Sidebar';
import Pusher from 'pusher-js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Switch from '@mui/material/Switch';
import axios from 'axios';
import Swal from 'sweetalert2';

function DefaultLayout() {
  const [productAlert, setProductAlert] = useState([]);
  const productcount = productAlert.length;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const [dashboardStats, setDashboardStats] = useState({
    todaySales: 0,
    todayOrders: 0,
    totalCustomers: 0,
    pendingInvoices: 0
  });
  const [isLoadingStats, setIsLoadingStats] = useState(true);

  useEffect(() => {
    const pusher = new Pusher('645b9acd1b4a187e96c6', {
      cluster: 'ap2',
    });

    const channel = pusher.subscribe('productAlertChenel');
    channel.bind('productAlertEvent', (data) => {
      const object = {
        'productName': data.productName,
        'qty': data.qty,
        'id': data.id
      };
      setProductAlert(prevProductAlert => [...prevProductAlert, object]);
    });

    return () => {
      channel.unbind();
      channel.unsubscribe();
    };
  }, []);

  const { user, token, setToken, setUser, setType, type, items, setItems, setUserId } = useStateContext();
  const stringitems = JSON.parse(items);
  const [pos, setPos] = useState(localStorage.getItem('pos') || '0');

  // Fetch dashboard stats
  useEffect(() => {
    if (type === 'Salesman') {
      fetchDashboardStats();
    }
  }, [type]);

  const fetchDashboardStats = async () => {
    setIsLoadingStats(true);
    try {
      // You can replace these with actual API calls
      // For now using mock data
      setDashboardStats({
        todaySales: 25400,
        todayOrders: 12,
        totalCustomers: 156,
        pendingInvoices: 3
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setIsLoadingStats(false);
    }
  };

  const handleOffcanClose = (data) => {
    setSidebarOpen(data);
  }

  const handleSubmitOffcan = () => {
    setSidebarOpen(true);
  }

  const closeSidebar = () => {
    setSidebarOpen(false);
  }

  const submitDayClose = () => {
    axios.get('/sanctum/csrf-cookie').then(res => {
      axios.get('api/stockdayclose').then(res => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.data,
          showConfirmButton: false,
          timer: 1500
        })
      })
    })
  }

  const submitLogout = () => {
    setToken(null);
    setUser(null);
    setType(null);
    setItems(null);
    setUserId(null);
  }

  const handlePosSetting = () => {
    const toggledPos = pos === '1' ? '0' : '1';
    if (toggledPos === '0') {
      toast.success('Switching To Thermal Printer', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.success('Switching To Invoice Printer', {
        position: "top-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setPos(toggledPos);
    localStorage.setItem('pos', toggledPos);
  }

  if (!token) {
    return <Navigate to='/login' />
  }

  // Salesman View - Professional White Background
  if (type === 'Salesman') {
    const isHome = location.pathname === '/';
    
    return (
      <div className="salesman-app">
        <style>{`
          /* Salesman Professional Style */
          .salesman-app {
            min-height: 100vh;
            background: #f0f2f5;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            padding-bottom: 70px;
          }

          /* Top Bar - White */
          .salesman-topbar {
            background: #ffffff;
            padding: 14px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: sticky;
            top: 0;
            z-index: 100;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06);
            border-bottom: 1px solid #e9ecef;
          }

          .salesman-topbar-left {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .salesman-topbar-logo {
            width: 36px;
            height: 36px;
            background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 18px;
          }

          .salesman-topbar-title {
            color: #1a2332;
            font-size: 17px;
            font-weight: 700;
            letter-spacing: -0.3px;
          }

          .salesman-topbar-title span {
            font-weight: 400;
            color: #7a8a9e;
            font-size: 12px;
            display: block;
            margin-top: -2px;
          }

          .salesman-topbar-right {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .salesman-icon-btn {
            color: #7a8a9e;
            font-size: 19px;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 8px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            background: none;
            border: none;
          }

          .salesman-icon-btn:hover {
            color: #4a6cf7;
            background: rgba(74, 108, 247, 0.08);
          }

          .salesman-icon-btn:active {
            transform: scale(0.95);
          }

          .salesman-icon-btn a {
            color: #7a8a9e;
            text-decoration: none;
            display: flex;
            align-items: center;
          }

          .salesman-icon-btn a:hover {
            color: #4a6cf7;
          }

          .salesman-cart-badge {
            position: absolute;
            top: 2px;
            right: 2px;
            background: #ff4757;
            color: white;
            font-size: 9px;
            font-weight: 700;
            border-radius: 50%;
            min-width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #ffffff;
            box-shadow: 0 2px 8px rgba(255,71,87,0.3);
          }

          /* Welcome Banner - Conditional */
          .salesman-welcome {
            background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
            margin: 16px 16px 0 16px;
            padding: 20px 24px;
            border-radius: 16px;
            color: white;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 20px rgba(74, 108, 247, 0.3);
          }

          .salesman-welcome-text {
            font-size: 15px;
            opacity: 0.9;
          }

          .salesman-welcome-text strong {
            font-size: 20px;
            display: block;
            margin-top: 4px;
          }

          .salesman-welcome-badge {
            background: rgba(255,255,255,0.2);
            padding: 6px 16px;
            border-radius: 50px;
            font-size: 12px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
          }

          /* Stats Cards */
          .salesman-stats {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
            padding: 16px;
          }

          .salesman-stat-item {
            background: #ffffff;
            border-radius: 14px;
            padding: 16px 14px;
            text-align: center;
            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
            border: 1px solid #e9ecef;
            transition: all 0.3s ease;
          }

          .salesman-stat-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          }

          .salesman-stat-item .stat-icon {
            font-size: 24px;
            margin-bottom: 6px;
            display: inline-block;
          }

          .salesman-stat-item .stat-value {
            font-size: 20px;
            font-weight: 700;
            color: #1a2332;
          }

          .salesman-stat-item .stat-label {
            font-size: 11px;
            color: #7a8a9e;
            font-weight: 500;
            margin-top: 2px;
          }

          .stat-icon-blue { color: #4a6cf7; }
          .stat-icon-green { color: #2ecc71; }
          .stat-icon-orange { color: #f39c12; }
          .stat-icon-red { color: #ff4757; }

          /* Bottom Navigation */
          .salesman-bottom-nav {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 6px 0 12px 0;
            box-shadow: 0 -2px 20px rgba(0,0,0,0.06);
            border-top: 1px solid #e9ecef;
            z-index: 100;
          }

          .salesman-nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1px;
            color: #7a8a9e;
            font-size: 9px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 4px 10px;
            border-radius: 10px;
            text-decoration: none;
            background: none;
            border: none;
            position: relative;
            min-width: 50px;
          }

          .salesman-nav-item svg {
            font-size: 20px;
            transition: all 0.3s ease;
          }

          .salesman-nav-item.active {
            color: #4a6cf7;
          }

          .salesman-nav-item.active svg {
            transform: translateY(-2px);
            filter: drop-shadow(0 2px 8px rgba(74, 108, 247, 0.3));
          }

          .salesman-nav-item.active::before {
            content: '';
            position: absolute;
            top: -1px;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 3px;
            background: #4a6cf7;
            border-radius: 0 0 4px 4px;
          }

          .salesman-nav-item:hover {
            color: #4a6cf7;
          }

          .salesman-nav-item:active {
            transform: scale(0.95);
          }

          .salesman-nav-cart-badge {
            position: absolute;
            top: -4px;
            right: 2px;
            background: #ff4757;
            color: white;
            font-size: 8px;
            font-weight: 700;
            border-radius: 50%;
            min-width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 8px rgba(255,71,87,0.3);
          }

          .salesman-outlet {
            padding: 12px 16px 16px 16px;
          }

          /* Hide stats on non-home pages */
          .hide-stats {
            display: none !important;
          }

          /* Responsive */
          @media (max-width: 576px) {
            .salesman-topbar {
              padding: 10px 14px;
            }
            .salesman-topbar-title {
              font-size: 15px;
            }
            .salesman-topbar-title span {
              font-size: 10px;
            }
            .salesman-icon-btn {
              font-size: 17px;
              padding: 6px;
            }
            .salesman-nav-item svg {
              font-size: 18px;
            }
            .salesman-nav-item {
              font-size: 8px;
              padding: 2px 6px;
              min-width: 40px;
            }
            .salesman-outlet {
              padding: 8px 10px 12px 10px;
            }
            .salesman-welcome {
              margin: 12px 10px 0 10px;
              padding: 16px 18px;
            }
            .salesman-welcome-text {
              font-size: 13px;
            }
            .salesman-welcome-text strong {
              font-size: 17px;
            }
            .salesman-stats {
              grid-template-columns: repeat(2, 1fr);
              padding: 12px 10px;
              gap: 8px;
            }
            .salesman-stat-item {
              padding: 12px 8px;
            }
            .salesman-stat-item .stat-value {
              font-size: 17px;
            }
            .salesman-stat-item .stat-icon {
              font-size: 20px;
            }
          }

          @media (max-width: 400px) {
            .salesman-topbar {
              padding: 8px 10px;
            }
            .salesman-topbar-title {
              font-size: 13px;
            }
            .salesman-topbar-logo {
              width: 30px;
              height: 30px;
              font-size: 14px;
            }
            .salesman-icon-btn {
              font-size: 15px;
              padding: 4px;
            }
            .salesman-nav-item {
              min-width: 35px;
            }
            .salesman-nav-item svg {
              font-size: 16px;
            }
            .salesman-stat-item .stat-value {
              font-size: 15px;
            }
          }
        `}</style>

        {/* Top Bar - White */}
        <div className="salesman-topbar">
          <div className="salesman-topbar-left">
            <div className="salesman-topbar-logo">
              <FaStore />
            </div>
            <div className="salesman-topbar-title">
              Sales Hub
              <span>Welcome, {user}</span>
            </div>
          </div>
          <div className="salesman-topbar-right">
            <button className="salesman-icon-btn">
              <Link to={'/myinvoices'}>
                <FaFileInvoice />
              </Link>
            </button>
            <button className="salesman-icon-btn">
              <Link to={'billdetail'}>
                <FaCartPlus />
                {stringitems && stringitems.length > 0 && (
                  <span className="salesman-cart-badge">{stringitems.length}</span>
                )}
              </Link>
            </button>
            <button className="salesman-icon-btn" onClick={submitLogout}>
              <FaSignOutAlt />
            </button>
          </div>
        </div>

        {/* Welcome Banner - Only on Home */}
        <div className={`salesman-welcome ${!isHome ? 'hide-stats' : ''}`}>
          <div className="salesman-welcome-text">
            Good to see you!
            <strong>{user}</strong>
          </div>
          <div className="salesman-welcome-badge">
            <FaStar /> Active
          </div>
        </div>

        {/* Stats Cards - Only on Home */}
        <div className={`salesman-stats ${!isHome ? 'hide-stats' : ''}`}>
          <div className="salesman-stat-item">
            <div className="stat-icon stat-icon-blue">
              <FaShoppingCart />
            </div>
            <div className="stat-value">
              {isLoadingStats ? '...' : dashboardStats.todaySales.toLocaleString()}
            </div>
            <div className="stat-label">Today's Sales</div>
          </div>
          <div className="salesman-stat-item">
            <div className="stat-icon stat-icon-green">
              <FaTruck />
            </div>
            <div className="stat-value">
              {isLoadingStats ? '...' : dashboardStats.todayOrders}
            </div>
            <div className="stat-label">Today's Orders</div>
          </div>
          <div className="salesman-stat-item">
            <div className="stat-icon stat-icon-orange">
              <FaUsers />
            </div>
            <div className="stat-value">
              {isLoadingStats ? '...' : dashboardStats.totalCustomers}
            </div>
            <div className="stat-label">Total Customers</div>
          </div>
          <div className="salesman-stat-item">
            <div className="stat-icon stat-icon-red">
              <FaClipboardList />
            </div>
            <div className="stat-value">
              {isLoadingStats ? '...' : dashboardStats.pendingInvoices}
            </div>
            <div className="stat-label">Pending Invoices</div>
          </div>
        </div>

        {/* Outlet */}
        <div className="salesman-outlet">
          <Outlet />
        </div>

        {/* Bottom Navigation - No Products Tab */}
        <div className="salesman-bottom-nav">
          <Link to={'/'} className={`salesman-nav-item ${location.pathname === '/' ? 'active' : ''}`}>
            <FaHome />
            <span>Home</span>
          </Link>
          <Link to={'billdetail'} className={`salesman-nav-item ${location.pathname === '/billdetail' ? 'active' : ''}`} style={{ position: 'relative' }}>
            <FaShoppingBag />
            {stringitems && stringitems.length > 0 && (
              <span className="salesman-nav-cart-badge">{stringitems.length}</span>
            )}
            <span>Cart</span>
          </Link>
          <Link to={'/myinvoices'} className={`salesman-nav-item ${location.pathname === '/myinvoices' ? 'active' : ''}`}>
            <FaFileInvoice />
            <span>Invoices</span>
          </Link>
          <Link to={'/reports'} className={`salesman-nav-item ${location.pathname === '/reports' ? 'active' : ''}`}>
            <FaChartLine />
            <span>Reports</span>
          </Link>
          <button className="salesman-nav-item" onClick={submitLogout}>
            <FaPowerOff />
            <span>Logout</span>
          </button>
        </div>
      </div>
    )
  }

  // Admin/Manager View
  return (
    <div className="dashboard-app">
      <style>{`
        /* ===== DASHBOARD LAYOUT ===== */
        .dashboard-app {
          min-height: 100vh;
          background: #f5f7fa;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }

        /* ===== TOP NAVBAR ===== */
        .dash-navbar {
          background: #ffffff;
          padding: 0 32px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06);
          border-bottom: 1px solid #e9ecef;
          position: sticky;
          top: 0;
          z-index: 1040;
        }

        .dash-nav-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .dash-nav-brand {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          color: #1a2332;
          font-weight: 700;
          font-size: 16px;
        }

        .dash-nav-brand svg {
          color: #4a6cf7;
          font-size: 20px;
        }

        .dash-nav-brand-badge {
          background: #4a6cf7;
          color: white;
          font-size: 10px;
          padding: 2px 10px;
          border-radius: 50px;
          font-weight: 600;
        }

        .dash-nav-user {
          color: #7a8a9e;
          font-size: 13px;
        }

        .dash-nav-user strong {
          color: #1a2332;
        }

        .dash-nav-right {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .dash-nav-item {
          display: flex;
          align-items: center;
          padding: 6px 12px;
          border-radius: 10px;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          background: none;
          border: none;
          color: #7a8a9e;
        }

        .dash-nav-item:hover {
          background: #f8f9fa;
          color: #4a6cf7;
        }

        /* ===== SIDEBAR TOGGLE ===== */
        .sidebar-toggle {
          background: none;
          border: none;
          color: #4a6cf7;
          font-size: 22px;
          cursor: pointer;
          padding: 6px;
          border-radius: 10px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sidebar-toggle:hover {
          background: rgba(74, 108, 247, 0.08);
        }

        /* ===== SIDEBAR OVERLAY ===== */
        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
          z-index: 1045;
          animation: fadeIn 0.3s ease;
          cursor: pointer;
          pointer-events: auto;
        }

        /* ===== SIDEBAR WRAPPER ===== */
        .sidebar-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          height: 100vh;
          z-index: 1050;
          pointer-events: none;
        }

        .sidebar-wrapper.active {
          pointer-events: auto;
        }

        .sidebar-wrapper > * {
          pointer-events: auto;
        }

        /* ===== SWITCH ===== */
        .printer-switch {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #7a8a9e;
        }

        .printer-switch .MuiSwitch-root {
          margin: 0 -6px;
        }

        .printer-switch span {
          font-weight: 500;
        }

        /* ===== NOTIFICATION BELL ===== */
        .bell-wrapper {
          position: relative;
        }

        .bell-icon {
          font-size: 19px;
          color: #7a8a9e;
          transition: all 0.3s ease;
          padding: 4px;
        }

        .bell-icon:hover {
          color: #4a6cf7;
        }

        .bell-badge {
          position: absolute;
          top: -2px;
          right: -2px;
          background: #ff4757;
          color: white;
          font-size: 9px;
          font-weight: 700;
          border-radius: 50%;
          min-width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #ffffff;
        }

        /* ===== DROPDOWN OVERRIDES ===== */
        .dropdown-toggle::after {
          display: none !important;
        }

        .nav-link {
          padding: 0 !important;
        }

        .dropdown-menu {
          border: none !important;
          border-radius: 12px !important;
          box-shadow: 0 8px 30px rgba(0,0,0,0.08) !important;
          border: 1px solid #e9ecef !important;
          padding: 6px 0 !important;
          min-width: 200px !important;
        }

        .dropdown-item {
          padding: 10px 20px !important;
          color: #1a2332 !important;
          font-size: 14px !important;
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          transition: all 0.2s ease !important;
        }

        .dropdown-item:hover {
          background: #f8f9fa !important;
          color: #4a6cf7 !important;
        }

        .dropdown-item svg {
          font-size: 16px;
          color: #7a8a9e;
        }

        .dropdown-divider {
          margin: 4px 0 !important;
          border-color: #e9ecef !important;
        }

        /* ===== NOTIFICATION DROPDOWN ===== */
        .notif-dropdown .dropdown-menu {
          min-width: 280px !important;
          max-height: 400px;
          overflow-y: auto;
        }

        .notif-item {
          padding: 10px 16px;
          color: #1a2332;
          font-size: 13px;
          text-decoration: none;
          display: block;
          transition: all 0.2s ease;
          border-bottom: 1px solid #f1f3f5;
        }

        .notif-item:hover {
          background: #f8f9fa;
          color: #4a6cf7;
        }

        .notif-empty {
          padding: 20px;
          color: #7a8a9e;
          font-size: 13px;
          text-align: center;
        }

        /* ===== OUTLET ===== */
        .dash-outlet {
          padding: 2px 2px;
        }

        /* ===== ANIMATIONS ===== */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideIn {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 992px) {
          .dash-navbar { padding: 0 20px; }
          .dash-nav-brand span { display: none; }
          .dash-nav-user { display: none; }
          .dash-outlet { padding: 20px; }
        }

        @media (max-width: 768px) {
          .dash-navbar { height: 56px; padding: 0 16px; }
          .dash-nav-right { gap: 4px; }
          .dash-nav-item { padding: 4px 8px; }
          .printer-switch span { display: none; }
          .dash-outlet { padding: 16px; }
        }

        @media (max-width: 576px) {
          .dash-navbar { height: 50px; padding: 0 12px; }
          .sidebar-toggle { font-size: 18px; padding: 4px; }
          .dash-nav-brand { font-size: 14px; }
          .dash-nav-brand-badge { display: none; }
          .dash-outlet { padding: 10px; }
          .bell-icon { font-size: 17px; }
          .notif-dropdown .dropdown-menu { min-width: 240px !important; }
        }

        /* ===== TOAST OVERRIDE ===== */
        .Toastify__toast {
          border-radius: 12px !important;
          font-family: inherit !important;
        }
      `}</style>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* ===== TOP NAVBAR ===== */}
      <div className="dash-navbar">
        <div className="dash-nav-left">
          <button className="sidebar-toggle" onClick={handleSubmitOffcan}>
            <FaBars />
          </button>
          <Link to={'/'} className="dash-nav-brand">
            <FaStore />
            <span>Dashboard</span>
            <span className="dash-nav-brand-badge">{type}</span>
          </Link>
          <span className="dash-nav-user">
            <strong>{user}</strong>
          </span>
        </div>

        <div className="dash-nav-right">
          {/* Printer Switch */}
          <div className="dash-nav-item">
            <div className="printer-switch">
              <Switch 
                color="primary" 
                checked={pos === '1'} 
                onClick={handlePosSetting}
                size="small"
              />
              <span>{pos === '1' ? 'Invoice' : 'Thermal'}</span>
            </div>
          </div>

          {/* Notification Bell */}
          <div className="dash-nav-item bell-wrapper notif-dropdown">
            <NavDropdown 
              title={
                <div className="bell-icon">
                  <FaBell />
                  {productcount > 0 && (
                    <span className="bell-badge">{productcount}</span>
                  )}
                </div>
              }
              id="notification-dropdown"
              align="end"
            >
              {productAlert.length === 0 ? (
                <div className="notif-empty">No notifications</div>
              ) : (
                productAlert.slice().reverse().map((item) => (
                  <Link 
                    to={'/add/product'} 
                    className="notif-item" 
                    key={item.id}
                  >
                    <strong>{item.productName}</strong> — {item.qty} items left
                  </Link>
                ))
              )}
            </NavDropdown>
          </div>

          {/* User Menu */}
          <div className="dash-nav-item">
            <NavDropdown 
              title={<FaPowerOff style={{ fontSize: '18px', color: '#7a8a9e' }} />}
              id="user-dropdown"
              align="end"
            >
              <button className="dropdown-item" onClick={submitLogout}>
                <FaSignOutAlt /> Logout
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={submitDayClose}>
                <FaCalendarDay /> Day Close
              </button>
            </NavDropdown>
          </div>
        </div>
      </div>

      {/* ===== OUTLET ===== */}
      <div className="dash-outlet">
        <Outlet />
      </div>

      {/* ===== SIDEBAR ===== */}
      {sidebarOpen && (
        <>
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
          <div className={`sidebar-wrapper active`}>
            <Sidebar show={sidebarOpen} onChildOffcanClose={handleOffcanClose} />
          </div>
        </>
      )}
    </div>
  )
}

export default DefaultLayout;